import constate from "constate";
import { useCallback, useState } from "react";

export const _useValidationInfo = () => {
  const [labels, setLabels] = useState<Record<string, string>>({});

  const getLabel = useCallback(
    (path: string) => {
      return labels[path] ?? null;
    },
    [labels],
  );

  const setLabel = useCallback((path: string, label: string) => {
    setLabels((previous) => ({
      ...previous,
      [path]: label,
    }));
  }, []);

  const removeLabel = useCallback((path: string) => {
    setLabels((prevState) =>
      Object.entries(prevState)
        .filter(([p]) => p !== path)
        .reduce(
          (acc, [p, l]) => ({
            ...acc,
            [p]: l,
          }),
          {},
        ),
    );
  }, []);

  return {
    labels,
    setLabel,
    getLabel,
    removeLabel,
  };
};

export const [
  ValidationInfoProvider,
  useValidationLabelUtils,
  useValidationFieldLabels,
] = constate(
  _useValidationInfo,
  ({ setLabel, getLabel, removeLabel }) => ({
    setLabel,
    getLabel,
    removeLabel,
  }),
  ({ labels }) => ({ labels }),
);
